module.exports = __webpack_public_path__ + "img/icon_yjh.219803cb.png";